export default __webpack_public_path__ + "static/media/1-10_icon.cddc8cd9.svg";